module.exports = __webpack_public_path__ + "static/media/icon-12.39101b39.png";